
    <div class="container">
      <div class="row mb-5">
        <div class="col-6">
          <form [formGroup]="form">
            <select-country [formControlName]="'country'"></select-country>
          </form>
        </div>
        <div class="col-6">
          <pre class="debug">value = {{ form.controls["country"].value }}, dirty = {{ form.controls["country"].dirty }}</pre>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-6">
          <form #manualForm="ngForm">
            <select-country name="country" [(ngModel)]="country"></select-country>
          </form>
        </div>
        <div class="col-6">
          <pre class="debug">value = {{ country }}, dirty = {{ manualForm.dirty }}</pre>
        </div>
      </div>
      <div class="row mb-5">
        <div class="btn-group float-right">
          <button class="btn btn-outline-primary" (click)="simulatePreload()">Simulate Preload</button>
        </div>
      </div>
    </div>
